import { ComponentProps } from "react";
import { CustomInput } from "./inputManualCalculation.styled";

type InputProps = ComponentProps<'input'> & {};

const Input: React.FC<InputProps> = ({ ...props }) => {

    return <CustomInput  {...props} />
};
export default Input;